<div class="container-fluid T-appoinmentform appointment-page">
  <div class="row">
    <div class="col-12">
      <div class="appointment-shell">
        <div class="list-toolbar">
          <div class="toolbar-title">
            <h3>Appointment List</h3>
            <p>Manage appointments with quick filters and direct actions.</p>
          </div>
          <button class="btn add-btn" type="button" (click)="openAddDialog()">
            <i class="pi pi-plus"></i>
            Add Appointment
          </button>
        </div>

        <div class="filters-grid">
          <input
            type="text"
            class="form-control filter-input"
            placeholder="Search patient, doctor, clinic, type, status..."
            [ngModel]="searchTerm"
            (ngModelChange)="onSearchChange($event)"
          />
          <select class="form-select filter-input" [(ngModel)]="selectedStatusFilter" (change)="onFilterChange()">
            <option value="all">All Status</option>
            <option *ngFor="let statusOpt of status" [value]="statusOpt.value">{{ statusOpt.label }}</option>
          </select>
          <select class="form-select filter-input" [(ngModel)]="selectedCourierFilter" (change)="onFilterChange()">
            <option value="all">OPD + Courier + MC</option>
            <option value="OPD">OPD</option>
            <option value="Courier">Courier</option>
            <option value="MC">MC</option>
          </select>
          <select class="form-select filter-input" [(ngModel)]="selectedScheduleFilter" (change)="onFilterChange()">
            <option value="all">All Schedule</option>
            <option value="Normal">Normal</option>
            <option value="Scheduled">Scheduled</option>
          </select>
          <input
            type="date"
            class="form-control filter-input"
            [(ngModel)]="selectedDateFilter"
            (change)="onFilterChange()"
          />
          <button class="btn clear-btn" type="button" (click)="clearFilters()">Clear</button>
        </div>

        <div class="table-wrap">
          <table class="table modern-table align-middle mb-0">
            <thead>
              <tr>
                <th class="sortable" (click)="setSort('patient_name')">Patient</th>
                <th class="sortable" (click)="setSort('appointment_date')">Date</th>
                <th class="sortable" (click)="setSort('start_time')">Time</th>
                <th class="sortable" (click)="setSort('appointment_type')">Type</th>
                <th class="sortable" (click)="setSort('scheduledLater')">Scheduled Later</th>
                <th class="sortable" (click)="setSort('status')">Status</th>
                <th class="sortable" (click)="setSort('isCourier')">OPD/Courier</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody *ngIf="isLoading">
              <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
                <td><p-skeleton width="100%"></p-skeleton></td>
                <td><p-skeleton width="100%"></p-skeleton></td>
                <td><p-skeleton width="100%"></p-skeleton></td>
                <td><p-skeleton width="100%"></p-skeleton></td>
                <td><p-skeleton width="100%"></p-skeleton></td>
                <td><p-skeleton width="100%"></p-skeleton></td>
                <td><p-skeleton width="100%"></p-skeleton></td>
                <td><p-skeleton width="100%"></p-skeleton></td>
              </tr>
            </tbody>
            <tbody *ngIf="!isLoading">
              <tr *ngFor="let row of paginatedAppointments">
                <td>{{ row.patient_name || '-' }}</td>
                <td>{{ row.appointment_date || '-' }}</td>
                <td>{{ row.start_time || '-' }}</td>
                <td>
                  <span class="type-pill" [ngClass]="getTypeClass(row.appointment_type)">
                    {{ row.appointment_type || '-' }}
                  </span>
                </td>
                <td>
                  <span class="later-pill" [class.yes]="row.scheduledLater === 'Scheduled'">
                    {{ row.scheduledLater || 'Normal' }}
                  </span>
                </td>
                <td>
                  <span class="status-pill" [ngClass]="getStatusClass(row.status)">{{ row.status || '-' }}</span>
                </td>
                <td>
                  <span class="channel-pill" [class.courier]="row.isCourier === 'Courier'">
                    {{ row.isCourier || 'OPD' }}
                  </span>
                  <span *ngIf="row.collectLater" class="mc-pill ms-1">MC</span>
                </td>
                <td class="action-cell">
                  <button class="btn table-icon edit" type="button" (click)="openEditDialog(row)" title="Edit">
                    <i class="pi pi-pencil"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!paginatedAppointments.length">
                <td colspan="8" class="empty-state">No appointments found.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-footer">
          <div class="footer-meta">
            Showing {{ paginatedAppointments.length }} of {{ totalAppointments }}
          </div>
          <div class="footer-controls">
            <select class="form-select page-size" [(ngModel)]="pageSize" (change)="updatePageSize()">
              <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} / page</option>
            </select>
            <button class="btn pager-btn" type="button" (click)="goToPreviousPage()" [disabled]="currentPage <= 1">
              Previous
            </button>
            <span class="page-indicator">Page {{ currentPage }} of {{ totalPages }}</span>
            <button class="btn pager-btn" type="button" (click)="goToNextPage()" [disabled]="currentPage >= totalPages">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="appointmentDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '80vw', maxWidth: '980px' }"
  [contentStyle]="{ overflow: 'visible' }"
  [header]="appointment.id ? 'Update Appointment' : 'Add Appointment'"
>
  <form class="row schedule-dialog-shell" formsElement>
    <div class="schedule-dialog-head">
      <div>
        <p>Select patient, appointment type, date, and an available slot.</p>
      </div>
      <div class="schedule-head-chips">
        <span class="head-chip available">
          <i class="pi pi-check-circle"></i>
          {{ availableSlotsCount }} available
        </span>
        <span class="head-chip blocked">
          <i class="pi pi-lock"></i>
          {{ blockedSlotsCount }} blocked
        </span>
      </div>
    </div>

    <div class="schedule-card">
      <div class="row">
        <div class="col-md-4 mb-4" *ngIf="!appointment.id">
          <label class="form-label d-block">Patient</label>
          <p-autoComplete
            name="patient_name"
            [(ngModel)]="selectedPatient"
            [suggestions]="patientList"
            (completeMethod)="searchPatients($event)"
            (onSelect)="onPatientSelect($event)"
            field="full_name"
            placeholder="Search by name, number, or contact"
            [forceSelection]="true"
            emptyMessage="No patients found"
            class="w-100"
          >
          </p-autoComplete>
        </div>

        <div class="col-md-4 mb-4" *ngIf="appointment.id">
          <label class="form-label d-block">Patient</label>
          <input type="text" class="form-control" id="patient_name" name="patient_name" [(ngModel)]="appointment.patient_name" readonly />
        </div>

        <div class="col-md-4 mb-4">
          <label for="appointment_type" class="form-label d-block">Appointment Type</label>
          <p-dropdown
            id="appointment_type"
            name="appointment_type"
            [options]="appointmentType"
            [(ngModel)]="appointment.appointment_type"
            optionLabel="label"
            optionValue="value"
            placeholder="Appointment Type"
            class="w-100"
          />
        </div>

        <div class="col-md-4 mb-4">
          <label for="status" class="form-label d-block">Status</label>
          <p-dropdown
            id="status"
            name="status"
            [options]="status"
            [(ngModel)]="appointment.status"
            optionLabel="label"
            optionValue="value"
            placeholder="Select a Status"
            class="w-100"
          />
        </div>

        <div class="col-md-4 mb-4">
          <label for="appointment_date" class="form-label d-block">Appointment Date</label>
          <input
            type="date"
            class="form-control schedule-date-input"
            id="appointment_date"
            name="appointment_date"
            (change)="generateTimeSlots()"
            [(ngModel)]="appointment.appointment_date"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mb-1">
          <div class="collect-later-wrap mt-1">
            <label class="collect-later-switch" for="collect_later">
              <input
                class="collect-later-input"
                type="checkbox"
                id="collect_later"
                name="collect_later"
                [(ngModel)]="appointment.collect_later"
              />
              <span class="collect-later-track" aria-hidden="true"></span>
              <span class="collect-later-copy">
                <span class="collect-later-title">Collect medicine later</span>
                <span class="collect-later-subtitle">Keep appointment flow unchanged, mark pickup for later.</span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 mb-4 schedule-card">
      <label for="time_slot" class="form-label d-block mb-2">Select Time Slot</label>
      <div class="slot-grid">
        <div class="slot-cell" *ngFor="let slot of timeSlots">
          <button
            name="time_slot"
            type="button"
            class="slot-btn"
            [class.selected]="selectedSlot === slot"
            [disabled]="slot.disabled"
            (click)="selectSlot(slot)"
          >
            {{ slot.label }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="appointment-dialog-footer">
      <button class="btn appointment-dialog-cancel" (click)="closeForm()">
        <i class="pi pi-times"></i> Cancel
      </button>
      <button
        class="btn appointment-dialog-confirm"
        [disabled]="!appointment.appointment_type || !appointment.status || !appointment.appointment_date || !appointment.start_time || (!appointment.id && !appointment.patient_id)"
        (click)="processAppointments()"
      >
        <i class="pi pi-check"></i>
        {{ appointment.id ? "Update" : "Add" }} Appointment
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ width: '450px' }" />
